import XLSX  from 'xlsx'

export function createRateExcel(excelData = {}) {
    /* original data */
    const filename = excelData.file_name || "write.xlsx";
    const headers = excelData.headers || []
    if (!excelData.data || !excelData.data.length) {
        alert('missing excel data')
    }
    let data = [];
    headers.map((x) => {
        data.push(x)
    })
    excelData.data.map((x)=>{
        data.push(x)
    })
    var ws_name = "Rate";

    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(data);
    // merge s=start, r=row, c=col, e=end
    if (excelData.merges)
        ws['!merges'] = excelData.merges
    
    /* add worksheet to  = workbook */
    XLSX.utils.book_append_sheet(wb, ws, ws_name);

    /* write workbook */
    XLSX.writeFile(wb, filename);
}

export function readExcel(excelFile) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = (e) => {
            let bstr = e.target.result
            let wb = XLSX.read(bstr, {type:'binary'})
            let wsname = wb.SheetNames[0]
            let ws = wb.Sheets[wsname]
            const data = XLSX.utils.sheet_to_row_object_array( ws, {defval:"", header:1} )
            return resolve( data );
            // ใช้ในกรณี sheet มากกว่า 1 
            // wb.SheetNames.forEach(function(sheetName) {
            //     let XL_row_object = XLSX.utils.sheet_to_row_object_array(wb.Sheets[sheetName])
            //     console.log( XL_row_object )
            //     let json_object = XL_row_object
            //     // console.log(json_object)
            // })
        }
        reader.onerror = (stuff) => {
            console.log("error", stuff)
            console.log (stuff.getMessage())
            return reject( stuff.getMessage() )
        }
        reader.readAsBinaryString( excelFile )
        
    })
}